  //咨询师模块
const consultant= () => import('@/views/consultant/index');
const home= () => import('@/views/consultant/home/index');
const message= () => import('@/views/consultant/message/message');
const mineStudent= () => import('@/views/consultant/student/mine/index');
const newStudent= () => import('@/views/consultant/student/new/index');

// 新的学生
const new_student_main= () => import('@/views/consultant/student/new/main');
const new_student_main_home= () => import('@/views/consultant/student/new/main/home');
const new_student_main_studentinformation= () => import('@/views/consultant/student/new/main/studentinformation');
const new_student_main_parentinformation= () => import('@/views/consultant/student/new/main/parentinformation');
const new_student_main_evaluationReport= () => import('@/views/consultant/student/new/main/evaluationReport');
const new_student_main_firstInterview= () => import('@/views/consultant/student/new/main/firstInterview');
const new_student_main_firstInterviewPartA= () => import('@/views/consultant/student/new/main/firstInterview/firstInterviewPartA');
const new_student_main_firstInterviewPartB= () => import('@/views/consultant/student/new/main/firstInterview/firstInterviewPartB');
const new_student_main_firstInterviewPartB2= () => import('@/views/consultant/student/new/main/firstInterview/firstInterviewPartB_2');

// 我的学生
const mine_student_main= () => import('@/views/consultant/student/mine/main');
// const mine_student_main= () => import('@/views/consultant/student/mine/main/home');
const mine_student_main_studentMessage= () => import('@/views/consultant/student/mine/main/studentMessage/index');
const mine_student_main_studentMessage_grade= () => import('@/views/consultant/student/mine/main/studentMessage/grade/index');
const mine_student_main_studentMessage_grade_list= () => import('@/views/consultant/student/mine/main/studentMessage/grade/list');
const mine_student_main_studentMessage_grade_add=() => import('@/views/consultant/student/mine/main/studentMessage/grade/add');
const mine_student_main_studentMessage_grade_detail = () => import('@/views/consultant/student/mine/main/studentMessage/grade/detail');

const mine_student_main_studentMessage_competition= () => import('@/views/consultant/student/mine/main/studentMessage/competition/index');
const mine_student_main_studentMessage_competition_list= () => import('@/views/consultant/student/mine/main/studentMessage/competition/list');
const mine_student_main_studentMessage_competition_add=() => import('@/views/consultant/student/mine/main/studentMessage/competition/add');
const mine_student_main_studentMessage_competition_detail = () => import('@/views/consultant/student/mine/main/studentMessage/competition/detail');

const mine_student_main_studentMessage_quality= () => import('@/views/consultant/student/mine/main/studentMessage/quality/index');
const mine_student_main_studentMessage_quality_list= () => import('@/views/consultant/student/mine/main/studentMessage/quality/list');
const mine_student_main_studentMessage_quality_add=() => import('@/views/consultant/student/mine/main/studentMessage/quality/add');
const mine_student_main_studentMessage_quality_detail = () => import('@/views/consultant/student/mine/main/studentMessage/quality/detail');

const mine_student_main_studentMessage_report= () => import('@/views/consultant/student/mine/main/studentMessage/report/report');
const mine_student_main_studentMessage_reportInterpretation=() => import('@/views/consultant/student/mine/main/studentMessage/report/reportInterpretation');

// 学习力报告
const mine_student_main_studentMessage_reportLearning= () => import('@/views/consultant/student/mine/main/studentMessage/reportLearning/learningReport2');
// 学习力报告解读
const mine_student_main_studentMessage_unscramble= () => import('@/views/consultant/student/mine/main/studentMessage/reportLearning/learningReportunscramble');

// 学习力报告3
const mine_student_main_studentMessage_reportLearning3= () => import('@/views/consultant/student/mine/main/studentMessage/reportLearning/learningReport3');
// 学习力报告解读3
const mine_student_main_studentMessage_unscramble3= () => import('@/views/consultant/student/mine/main/studentMessage/reportLearning/learningReportunscramble3');




const mine_student_main_studentMessage_studentQues= () => import('@/views/consultant/student/mine/main/studentMessage/studentQues/studentMessage.vue');
const mine_student_main_studentMessage_parentQues=() => import('@/views/consultant/student/mine/main/studentMessage/parentQues/parentMessage.vue');


const mine_student_main_planningContent= () => import('@/views/consultant/student/mine/main/planningContent/index');
const mine_student_main_planningContent_recordList= () => import('@/views/consultant/student/mine/main/planningContent/recordList');
const mine_student_main_planningContent_addfirstPlaning=() => import('@/views/consultant/student/mine/main/planningContent/addFirstPlaning.vue');
const mine_student_main_planningContent_addfirstPlaning_A=() => import('@/views/consultant/student/mine/main/planningContent/addFirstPlaning_A.vue');
const mine_student_main_planningContent_planningReport = () => import('@/views/consultant/student/mine/main/planningContent/planningReport.vue');
const mine_student_main_planningContent_planningAdjustment= () => import('@/views/consultant/student/mine/main/planningContent/planningAdjustment.vue');
const mine_student_main_planningContent_adjustmentReport= () => import('@/views/consultant/student/mine/main/planningContent/adjustmentReport.vue');




const mine_student_main_consultationRecord= () => import('@/views/consultant/student/mine/main/consultationRecord/index');
const mine_student_main_consultationRecord_student= () => import('@/views/consultant/student/mine/main/consultationRecord/student/index');
const mine_student_main_consultationRecord_student_studentRecord=() => import('@/views/consultant/student/mine/main/consultationRecord/student/list.vue');
const mine_student_main_consultationRecord_student_add = () => import('@/views/consultant/student/mine/main/consultationRecord/student/add.vue');
const mine_student_main_consultationRecord_student_detail= () => import('@/views/consultant/student/mine/main/consultationRecord/student/detail.vue');

const mine_student_main_consultationRecord_parent= () => import('@/views/consultant/student/mine/main/consultationRecord/parent/index');
const mine_student_main_consultationRecord_parent_parentRecord=() => import('@/views/consultant/student/mine/main/consultationRecord/parent/list.vue');
const mine_student_main_consultationRecord_parent_add = () => import('@/views/consultant/student/mine/main/consultationRecord/parent/add.vue');
const mine_student_main_consultationRecord_parent_detail= () => import('@/views/consultant/student/mine/main/consultationRecord/parent/detail.vue');


// 我的学生-数据分析
const mine_student_main_dataAnalysis= () => import('@/views/consultant/student/mine/main/dataAnalysis/index');
const mine_student_main_dataAnalysis_actionPlan= () => import('@/views/consultant/student/mine/main/dataAnalysis/actionPlan');
const mine_student_main_dataAnalysis_grade= () => import('@/views/consultant/student/mine/main/dataAnalysis/grade');

//我的学生-计划执行
const mine_student_main_implement= () => import('@/views/consultant/student/mine/main/implement/index');
const mine_student_main_implement_targetSplit= () => import('@/views/consultant/student/mine/main/implement/targetSplit');
const mine_student_main_implement_actionPlan= () => import('@/views/consultant/student/mine/main/implement/actionPlan');
const mine_student_main_implement_assessment= () => import('@/views/consultant/student/mine/main/implement/assessment');

//我的学生-计划执行-阶段评估
const mine_student_main_implement_assessment_list= () => import('@/views/consultant/student/mine/main/implement/assessment/list');
const mine_student_main_implement_assessment_add= () => import('@/views/consultant/student/mine/main/implement/assessment/add');
const mine_student_main_implement_assessment_show= () => import('@/views/consultant/student/mine/main/implement/assessment/show');

//我的学生-计划执行-目标拆分
const mine_student_main_implement_targetSplit_list= () => import('@/views/consultant/student/mine/main/implement/targetSplit/list');
const mine_student_main_implement_targetSplit_add= () => import('@/views/consultant/student/mine/main/implement/targetSplit/add');
const mine_student_main_implement_targetSplit_show= () => import('@/views/consultant/student/mine/main/implement/targetSplit/show');
const mine_student_main_implement_targetSplit_update= () => import('@/views/consultant/student/mine/main/implement/targetSplit/update');
const mine_student_main_implement_targetSplit_preview= () => import('@/views/consultant/student/mine/main/implement/targetSplit/preview');

//我的学生-计划执行-行动计划
const mine_student_main_implement_actionPlan_list= () => import('@/views/consultant/student/mine/main/implement/actionPlan/list');
const mine_student_main_implement_actionPlan_add= () => import('@/views/consultant/student/mine/main/implement/actionPlan/add');
const mine_student_main_implement_actionPlan_show= () => import('@/views/consultant/student/mine/main/implement/actionPlan/show');
const mine_student_main_implement_actionPlan_preview= () => import('@/views/consultant/student/mine/main/implement/actionPlan/preview');
const mine_student_main_implement_actionPlan_gradeDetail= () => import('@/views/consultant/student/mine/main/implement/actionPlan/gradeDetail');
const mine_student_main_implement_actionPlan_gradeDetailassessment= () => import('@/views/consultant/student/mine/main/implement/actionPlan/gradeDetailassessment');
const mine_student_main_implement_actionPlan_assessmentAdd= () => import('@/views/consultant/student/mine/main/implement/actionPlan/assessmentAdd');
const mine_student_main_implement_actionPlan_assessmentShow= () => import('@/views/consultant/student/mine/main/implement/actionPlan/assessmentShow');
const mine_student_main_implement_actionPlan_assessmentPreview= () => import('@/views/consultant/student/mine/main/implement/actionPlan/assessmentPreview');

//我的学生-成长档案
const mine_student_main_growthFile_index= () => import('@/views/consultant/student/mine/main/growthFile/index');
const mine_student_main_growthFile_entry=() => import('@/views/consultant/student/mine/main/growthFile/entry.vue');
const mine_student_main_growthFile_report = () => import('@/views/consultant/student/mine/main/growthFile/report.vue');
export default  {
    consultant:[
        {
            path:'/consultant/home',
            component:home,
            meta:{requireAuth:true,roles:['consultant']}
        },
        {
            path:'/consultant/message',
            component:message,
            meta:{requireAuth:true,roles:['consultant']}
        },
        {
            path:'/consultant/newstudent',
            component:newStudent,
            meta:{requireAuth:true,roles:['consultant']}
        },
        {
            path:'/consultant/newstudent/main',
            component:new_student_main,
            children:[
                {
                    path:'/consultant/newstudent/main/home',
                    component:new_student_main_home,
                    meta:{requireAuth:true,roles:['consultant']}
                },
                {
                    path:'/consultant/newstudent/main/studentinformation',
                    component:new_student_main_studentinformation,
                    meta:{requireAuth:true,roles:['consultant']}
                },
                {
                    path:'/consultant/newstudent/main/parentinformation',
                    component:new_student_main_parentinformation,
                    meta:{requireAuth:true,roles:['consultant']},
                },
                {
                    path:'/consultant/newstudent/main/evaluationReport',
                    component:new_student_main_evaluationReport,
                    meta:{requireAuth:true,roles:['consultant']}
                },
                {
                    path:'/consultant/newstudent/main/firstInterview',
                    component:new_student_main_firstInterview,
                    meta:{requireAuth:true,roles:['consultant']}
                },
                
                {
                    path:'/consultant/newstudent/main/firstInterviewPartB',
                    component:new_student_main_firstInterviewPartB,
                    meta:{requireAuth:true,roles:['consultant']}
                },
                {
                    path:'/consultant/newstudent/main/firstInterviewPartB2',
                    component:new_student_main_firstInterviewPartB2,
                    meta:{requireAuth:true,roles:['consultant']}
                },
            ]
        },
        {
            path:'/consultant/minestudent',
            component:mineStudent,
            meta:{requireAuth:true,roles:['consultant']}
        },
        {
            path:'/consultant/minestudent/main',
            component:mine_student_main,
            redirect:'/consultant/minestudent/main/studentMessage',
            
            children:[
                {
                    path:'/consultant/newstudent/main/firstInterviewPartA',
                    component:new_student_main_firstInterviewPartA,
                    meta:{requireAuth:true,roles:['consultant']}
                },
                {
                    path: "/consultant/minestudent/main/studentMessage",
                    component: mine_student_main_studentMessage,
                    redirect: '/consultant/minestudent/main/studentMessage/grade',
                    children: [
                        {
                            path: '/consultant/minestudent/main/studentMessage/grade',
                            component: mine_student_main_studentMessage_grade,
                            redirect: '/consultant/minestudent/main/studentMessage/grade/list',
                            children: [
                                {
                                    path: '/consultant/minestudent/main/studentMessage/grade/list',
                                    component: mine_student_main_studentMessage_grade_list,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/studentMessage/grade/add',
                                    component: mine_student_main_studentMessage_grade_add,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/studentMessage/grade/detail',
                                    component: mine_student_main_studentMessage_grade_detail,
                                    meta:{requireAuth:true,roles:['consultant']}
                                }]
                        },
                        {
                            path: '/consultant/minestudent/main/studentMessage/competition',
                            component: mine_student_main_studentMessage_competition,
                            redirect: '/consultant/minestudent/main/studentMessage/competition/list',
                            children: [
                                {
                                    path: '/consultant/minestudent/main/studentMessage/competition/list',
                                    component: mine_student_main_studentMessage_competition_list,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/studentMessage/competition/add',
                                    component: mine_student_main_studentMessage_competition_add,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/studentMessage/competition/detail',
                                    component: mine_student_main_studentMessage_competition_detail,
                                    meta:{requireAuth:true,roles:['consultant']}
                                }
                            ]
                        },
                        {
                            path: '/consultant/minestudent/main/studentMessage/quality',
                            component: mine_student_main_studentMessage_quality,
                            redirect: '/consultant/minestudent/main/studentMessage/quality/list',
                            children: [
                                {
                                    path: '/consultant/minestudent/main/studentMessage/quality/list',
                                    component: mine_student_main_studentMessage_quality_list,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/studentMessage/quality/add',
                                    component: mine_student_main_studentMessage_quality_add,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/studentMessage/quality/detail',
                                    component: mine_student_main_studentMessage_quality_detail,
                                    meta:{requireAuth:true,roles:['consultant']}
                                }
                            ]
                        },
                        {
                            path: '/consultant/minestudent/main/studentMessage/student',
                            component: mine_student_main_studentMessage_studentQues,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/studentMessage/parent',
                            component: mine_student_main_studentMessage_parentQues,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/studentMessage/report',
                            component: mine_student_main_studentMessage_report,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/studentMessage/reportInterpretation',
                            component: mine_student_main_studentMessage_reportInterpretation,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        // 学习力报告
                        {
                            path: '/consultant/minestudent/main/studentMessage/reportLearning/learningReport2',
                            component: mine_student_main_studentMessage_reportLearning,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        // 学习力报告解读
                        {
                            path: '/consultant/minestudent/main/studentMessage/reportLearning/learningReportunscramble',
                            component: mine_student_main_studentMessage_unscramble,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        // 学习力报告3
                        {
                            path: '/consultant/minestudent/main/studentMessage/reportLearning/learningReport3',
                            component: mine_student_main_studentMessage_reportLearning3,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        // 学习力报告解读3
                        {
                            path: '/consultant/minestudent/main/studentMessage/reportLearning/learningReportunscramble3',
                            component: mine_student_main_studentMessage_unscramble3,
                            meta:{requireAuth:true,roles:['consultant']}
                        },


                    ]
                },
                {
                    path: "/consultant/minestudent/main/planningContent",
                    component: mine_student_main_planningContent,
                    redirect: '/consultant/minestudent/main/planningContent/recordList',
                    children: [
                        {
                            path: '/consultant/minestudent/main/planningContent/recordList',
                            component: mine_student_main_planningContent_recordList,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/planningContent/addFirstPlaning',
                            component: mine_student_main_planningContent_addfirstPlaning,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/planningContent/addFirstPlaning_A',
                            component: mine_student_main_planningContent_addfirstPlaning_A,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/planningContent/planningReport',
                            component: mine_student_main_planningContent_planningReport,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/planningContent/planningAdjustment',
                            component: mine_student_main_planningContent_planningAdjustment,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/planningContent/adjustmentReport',
                            component: mine_student_main_planningContent_adjustmentReport,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                    ]
                },

                {
                    path: '/consultant/minestudent/main/dataAnalysis',
                    component: mine_student_main_dataAnalysis,
                    children: [
                        {
                            path: '/consultant/minestudent/main/dataAnalysis/grade',
                            component: mine_student_main_dataAnalysis_grade,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/dataAnalysis/actionplan',
                            component: mine_student_main_dataAnalysis_actionPlan,
                            meta:{requireAuth:true,roles:['consultant']}
                        }
                    ]
                },

                {
                    path: '/consultant/minestudent/main/implement',
                    component: mine_student_main_implement,
                    children: [
                        {
                            path: '/consultant/minestudent/main/implement/targetsplit',
                            component: mine_student_main_implement_targetSplit,
                            redirect: '/consultant/minestudent/main/implement/targetsplit/list',
                            children: [
                                {
                                    path: '/consultant/minestudent/main/implement/targetsplit/list',
                                    component: mine_student_main_implement_targetSplit_list,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/targetsplit/show',
                                    component: mine_student_main_implement_targetSplit_show,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/targetsplit/add',
                                    component: mine_student_main_implement_targetSplit_add,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/targetsplit/update',
                                    component: mine_student_main_implement_targetSplit_update,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/targetsplit/preview',
                                    component: mine_student_main_implement_targetSplit_preview,
                                    meta:{requireAuth:true,roles:['consultant']}
                                }
                            ]
                        },
                        {
                            path: '/consultant/minestudent/main/implement/actionplan',
                            component: mine_student_main_implement_actionPlan,
                            redirect: '/consultant/minestudent/main/implement/actionplan/list',
                            children: [
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/list',
                                    component: mine_student_main_implement_actionPlan_list,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/add',
                                    component: mine_student_main_implement_actionPlan_add,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/show',
                                    component: mine_student_main_implement_actionPlan_show,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/preview',
                                    component: mine_student_main_implement_actionPlan_preview,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/gradeDetail',
                                    component: mine_student_main_implement_actionPlan_gradeDetail,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/gradeDetailassessment',
                                    component: mine_student_main_implement_actionPlan_gradeDetailassessment,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/assessmentAdd',
                                    component: mine_student_main_implement_actionPlan_assessmentAdd,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/assessmentShow',
                                    component: mine_student_main_implement_actionPlan_assessmentShow,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/actionplan/assessmentPreview',
                                    component: mine_student_main_implement_actionPlan_assessmentPreview,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                            ]
                        },
                        {
                            path: '/consultant/minestudent/main/implement/assessment',
                            component: mine_student_main_implement_assessment,
                            redirect: '/consultant/minestudent/main/implement/assessment/list',
                            children: [
                                {
                                    path: '/consultant/minestudent/main/implement/assessment/list',
                                    component: mine_student_main_implement_assessment_list,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/assessment/show',
                                    component: mine_student_main_implement_assessment_show,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/implement/assessment/add',
                                    component: mine_student_main_implement_assessment_add,
                                    meta:{requireAuth:true,roles:['consultant']}
                                }
                            ]
                        },
                    ]
                },
                {
                    path:"/consultant/minestudent/main/consultationRecord",
                    component: mine_student_main_consultationRecord,
                    redirect:'/consultant/minestudent/main/consultationRecord/student',
                    children:[
                        {
                            path: '/consultant/minestudent/main/consultationRecord/student',
                            component: mine_student_main_consultationRecord_student,
                            redirect:'/consultant/minestudent/main/consultationRecord/student/studentrecord',
                            children:[
                                {
                                    path: '/consultant/minestudent/main/consultationRecord/student/studentrecord',
                                    component: mine_student_main_consultationRecord_student_studentRecord,
                                    meta:{requireAuth:true,roles:['consultant']}

                                },
                                {
                                    path: '/consultant/minestudent/main/consultationRecord/student/add',
                                    component: mine_student_main_consultationRecord_student_add,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                                {
                                    path: '/consultant/minestudent/main/consultationRecord/student/detail',
                                    component: mine_student_main_consultationRecord_student_detail,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },
                            ]
                        },
                        {

                            path: '/consultant/minestudent/main/consultationRecord/parent',
                            component: mine_student_main_consultationRecord_parent,
                            redirect:'/consultant/minestudent/main/consultationRecord/parent/parentrecord',
                            children:[
                                {
                                    path: '/consultant/minestudent/main/consultationRecord/parent/parentrecord',
                                    component: mine_student_main_consultationRecord_parent_parentRecord,
                                    meta:{requireAuth:true,roles:['consultant']}

                                },
                                {
                                    path: '/consultant/minestudent/main/consultationRecord/parent/add',
                                    component: mine_student_main_consultationRecord_parent_add,
                                    meta:{requireAuth:true,roles:['consultant']}

                                },
                                {
                                    path: '/consultant/minestudent/main/consultationRecord/parent/detail',
                                    component: mine_student_main_consultationRecord_parent_detail,
                                    meta:{requireAuth:true,roles:['consultant']}
                                },

                            ]
                        },

                    ]
                },
                {
                    path:"/consultant/minestudent/main/growthFile",
                    component: mine_student_main_growthFile_index,
                    redirect:'/consultant/minestudent/main/growthFile/entry',
                    children:[
                        {
                            path: '/consultant/minestudent/main/growthFile/entry',
                            component: mine_student_main_growthFile_entry,
                            meta:{requireAuth:true,roles:['consultant']}
                        },
                        {
                            path: '/consultant/minestudent/main/growthFile/report',
                            component: mine_student_main_growthFile_report,
                            meta:{requireAuth:true,roles:['consultant']}
                        }
                    ]
                },
            ]
        },
    ]
}
